import {Pipe, PipeTransform} from '@angular/core';
import {ExperienceDurationDto} from '../../models/ExperiencesModels';

const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 1440;

@Pipe({name: 'experienceDuration'})
export class ExperienceDurationPipe implements PipeTransform {
    transform(duration: ExperienceDurationDto): string {
        if (duration.minMinutes === duration.maxMinutes) {
            return formatMinutes(duration.minMinutes);
        }
        return `${formatMinutes(duration.minMinutes)} – ${formatMinutes(duration.maxMinutes)}`;
    }
}

function formatMinutes(minutes: number): string {
    if (minutes >= MINUTES_PER_DAY && minutes % MINUTES_PER_DAY === 0) {
        return pluralize(minutes / MINUTES_PER_DAY, 'day');
    }
    if (minutes >= MINUTES_PER_HOUR) {
        const hours = Math.floor(minutes / MINUTES_PER_HOUR);
        const remainingMinutes = minutes % MINUTES_PER_HOUR;
        return remainingMinutes === 0
            ? pluralize(hours, 'hr')
            : `${pluralize(hours, 'hr')} ${remainingMinutes} min`;
    }
    return `${minutes} min`;
}

function pluralize(count: number, unit: string): string {
    return `${count} ${unit}${count === 1 ? '' : 's'}`;
}
